import type { FC } from 'react'
import type { CmsDataService } from './cms.data.service'
import type { CmsService } from './cms.service'
import type { InitialDataResponse } from './models/initialDataResponse'
import type { BasePagesEnum, BaseSubPageKey } from './models/pagelist-models'
import type { NavigationService } from './navigation.service'
import { occService } from './occ.service'
import type { UrlService } from './url.service'

export class Services {
    public static NavigationService: NavigationService<BasePagesEnum, BaseSubPageKey<BasePagesEnum>>
    public static OccService = occService
    public static UrlService: UrlService<BasePagesEnum, BaseSubPageKey<BasePagesEnum>>
    public static CmsDataService: CmsDataService<InitialDataResponse>
    public static CmsService: CmsService<InitialDataResponse, BasePagesEnum>
}

export class OmniaComponents {
    public static ErrorBoundary?: FC = undefined
    public static Loading?: FC = undefined
}
